module.exports = __webpack_public_path__ + "static/media/inventory.e2b26036.svg";